import $ from 'sbf-design-system/js/jquery';
import banner from 'sbf-design-system-component/banners/banner';
import Overlay from 'sbf-design-system-component/overlays/overlay';

const defaultWidgetOpts = {
  force_solo: true,
  full_screen: true
};

window.SBFBanner = banner;

const widgetOverlay = new Overlay($('#widgetOverlay'), defaultWidgetOpts);
const iframe = $('[name=donationWidgetName]');
const iframeWrapper = $('#iframeWidgetWrapper');

$('.widget-overlay-trigger').on('click', function () {
  console.log('You clicked a button...');
  console.log(`Current donation widget url ${window.sbfDonateWidgetCurrentUrl}`);

  const newlinkURL = this.href.replace(/#.*$/, '');
  console.log(`newlinkURL ${newlinkURL}`);

  // if the url has changed...
  if (newlinkURL !== window.sbfDonateWidgetCurrentUrl) {
    iframeWrapper.addClass('loading');
    iframeWrapper.prepend('<div class="spinner"></div>');
    iframe.fadeOut(0);
  }

  // Update the Current URL
  window.sbfDonateWidgetCurrentUrl = newlinkURL;
  console.log(`Updated current donation widget url ${window.sbfDonateWidgetCurrentUrl}`);

  // Open the overlay
  widgetOverlay.show();
});

// Show the iframe once it is loaded.
iframe.on('load', function () {
  console.log('the iframe is loaded');

  // Give the widget js a moment to load our query parameters
  setTimeout(function () {
    // Fade in the iframe
    $(this).fadeIn();
  }.bind(this), 60);
  iframeWrapper.removeClass('loading');
  $('.spinner').remove();
});
